import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { NgClass, NgIf, CurrencyPipe, DatePipe, NgForOf } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { MatTabsModule } from '@angular/material/tabs';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaxSelectorDialogComponent } from '../pax-selector-dialog/pax-selector-dialog.component';
import { FormsModule } from '@angular/forms';
import { UploaderComponent } from '../uploader/uploader.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'capture-payment',
  standalone: true,
  imports: [NgIf, MatIconModule,FormsModule, CarouselAllModule, MatTabsModule, CurrencyPipe, FuseDrawerComponent, MatButtonModule, GoogleMapsModule, DatePipe, MatTooltipModule, NgForOf, MatDialogModule, NgClass,UploaderComponent],
  providers: [TFMService],
  templateUrl: './capture-payment-dialog.component.html',
  styleUrl: './capture-payment-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Default
})
export class CapturePaymentComponent implements OnInit {

  public view : any = {
    payment: {
      paymentMethod: '',
      paymentDate: null,
      baseAmount: null,
      referenceNumber: '',
      description: '',
      isComplete: false
    },
    paymentMethods: [
      { id: 1, name: 'Credit Card' },
      { id: 2, name: 'EFT' },
      { id: 3, name: 'Debit Card' }
    ],
    itineraryOption: {
      payments: {
        content: [] 
      }
    }
  }
  public calendar = {
    getToday: () => new Date(),
    getNext: (date: Date, unit: string, value: number) => {
      const result = new Date(date);
      switch (unit) {
        case 'd': // Days
          result.setDate(result.getDate() + value);
          break;
        case 'm': // Months
          result.setMonth(result.getMonth() + value);
          break;
        case 'y': // Years
          result.setFullYear(result.getFullYear() + value);
          break;
        default:
          break;
      }
      return result;
    }
  };

  public minDate: Date;
  public user: any = {};
  /**
   * Constructor
   */
  constructor(private _tfmService : TFMService, private _tfmCartService: TFMCartService, public dialogRef: MatDialogRef<PaxSelectorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog)
  {
    // this.view.type = data.type;
    // this.view.search = data.search;
    // this.view.config = data.config;
    this._tfmService.log("Data - : ",data.itinerary)
    this.view.itineraryOption = this.data.itinerary;
    this._tfmService.log("Data - 2 : ",this.view.itineraryOption )

    
  }

  /**
  * On init
  */
  ngOnInit(): void {
    // this.view.setItineraryOption = this.data

    this._tfmService.getLoggedInUser().subscribe(res => {
      this.user = res;

      if (this.user.agentType == 'AGENT')
        this.minDate = this.calendar.getNext(this.calendar.getToday(), 'd', 5);
      else
        this.minDate = this.calendar.getToday();
    });
    this.getPayments(this.view.itineraryOption)
  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
        this.dialog.open(ConfirmationDialogComponent, {
          data: config
        });
      }
  savePayment() {
    if (this.view.payment && this.data) {
      //this._tfmservice.log("Save payment", this.view.payment, this.view.itineraryOption);

      this.view.payment.isComplete = 1;
      this._tfmService.log('itineraryOption',this.view.itineraryOption._links)
      // this._tfmservice.log("88888")

      this._tfmService.filterAndSend(this.view.itineraryOption._links, "payments").subscribe(res => {
        this._tfmService.log("Response",res)
        this._tfmService.log("Payment Payload",this.view.payment)
        this._tfmService.filterAndSend(res._links, "add", this.view.payment).subscribe(res => {
          this._tfmService.log('res',res);
          this.view.payment = res;
          this._tfmService.log("Payment added, please upload proof of payment...");
          this.openConfirmationModal({
            title: 'Payment made',
            message: 'The Payment  has been added successfully',
            showClose: true,
            showViewQuotes: false,
            showNewQuote: false
          });
          // this.itinOptionsLoad();

          this._tfmService.filterAndSend(this.view.itineraryOption._links, "payments").subscribe(res => {
            this.view.itineraryOption.payments = res;
          });
          
        });
      });
    }
    else{
      this._tfmService.log("view.payment not found")
    }
  }
  removePayment(paymentItem) {
    if (this.user.agentType == 'ADMIN') {
      this._tfmService.log("Admin");
      this._tfmService.filterAndSend(paymentItem._links, "delete").subscribe(res => {
        this._tfmService.log("Payment removed");

          this.dialogRef.close();
          this.openConfirmationModal({
            title: 'Payment removed',
            message: 'The Payment  has been removed successfully',
            showClose: true,
            showViewQuotes: false,
            showNewQuote: false
          });

        this._tfmService.filterAndSend(this.view.payment._links, "payments").subscribe(res => {
          this.view.itineraryOption.payments = res;
        });
      });
    }
    else {
      this._tfmService.log("Permission denied");
    }
  }


  apply(): void {
    // Handle the apply logic here
    this.dialogRef.close(this.view.itineraryOption.payments.content);
  }

  close(): void
  {
      // Close the dialog
      this.dialogRef.close();
  }


  getPayments(itinerary) {
    this._tfmService.filterAndSend(itinerary._links, "payments").subscribe(res => {
      itinerary.payments = res;
      this._tfmService.log('itinerary.payments',itinerary.payments)
    });
  }
  
 
  
}
